import mavonEditor from 'mavon-editor';
import mdFigure from './figure';

mavonEditor.markdownIt.use(mdFigure, {
    dataType: true,
    figcaption: true,
    link: false
});

export default mavonEditor.markdownIt;
